/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AppClientVersionQueryVariables = GraphQL.Exact<{ [key: string]: never; }>;


export type AppClientVersionQuery = { readonly __typename?: 'Query', readonly appClientVersion: number };


export const AppClientVersionDocument = gql`
    query AppClientVersion {
  appClientVersion
}
    `;

/**
 * __useAppClientVersionQuery__
 *
 * To run a query within a React component, call `useAppClientVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppClientVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppClientVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppClientVersionQuery(baseOptions?: Apollo.QueryHookOptions<AppClientVersionQuery, AppClientVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppClientVersionQuery, AppClientVersionQueryVariables>(AppClientVersionDocument, options);
      }
export function useAppClientVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppClientVersionQuery, AppClientVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppClientVersionQuery, AppClientVersionQueryVariables>(AppClientVersionDocument, options);
        }
export function useAppClientVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppClientVersionQuery, AppClientVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppClientVersionQuery, AppClientVersionQueryVariables>(AppClientVersionDocument, options);
        }
export type AppClientVersionQueryHookResult = ReturnType<typeof useAppClientVersionQuery>;
export type AppClientVersionLazyQueryHookResult = ReturnType<typeof useAppClientVersionLazyQuery>;
export type AppClientVersionSuspenseQueryHookResult = ReturnType<typeof useAppClientVersionSuspenseQuery>;
export type AppClientVersionQueryResult = Apollo.QueryResult<AppClientVersionQuery, AppClientVersionQueryVariables>;